import Img1 from "../assets/images/news1.png";
import Img2 from "../assets/images/news2.png";
import Img3 from "../assets/images/news3.png";
import Img4 from "../assets/images/news4.png";
export const latestNews = [
  {
    newsHeading: "BEWARE OF FALSE REPRESEN…….",
    img: Img1,
    date: "25 june 2023",
    view: "59",
    comment: "19",
    newsDetails:
      "Dear Esteemed Members of NAPPS Nigeria . It has come to our attention that individuals are claiming to be representatives of NAPPS Nigeria Exco and members of the Unified…….",
    moreDetails:
      "Our seven research themes span the full range of research activities being carried out in the Laboratory and reflect national research priorities. Many themes cover the work of more than one research group, encouraging new associations and cross-disciplinary collaboration. While the core of our research programme is in experimental physics, essential theoretical support is provided by theorists embedded within the astrophysics and high energy physics research groups, while the condensed matter theory group are strongly cross-disciplinary and contribute to most of the themes shown above.",

    id: 1,
  },
  {
    newsHeading: "PREPARE YOUR STUDENTS FOR……",
    img: Img2,
    date: "25 june 2023",
    view: "59",
    comment: "19",
    newsDetails:
      "The key to producing top achievers from preschool to SS! Don’t miss out on the opportunity to equip your learners with quality ...",
    moreDetails:
      "Our seven research themes span the full range of research activities being carried out in the Laboratory and reflect national research priorities. Many themes cover the work of more than one research group, encouraging new associations and cross-disciplinary collaboration. While the core of our research programme is in experimental physics, essential theoretical support is provided by theorists embedded within the astrophysics and high energy physics research groups, while the condensed matter theory group are strongly cross-disciplinary and contribute to most of the themes shown above.",

    id: 2,
  },
  {
    newsHeading: "REGISTRATION FOR THIRD TERM….",
    img: Img3,
    date: "25 june 2023",
    view: "59",
    comment: "19",
    newsDetails:
      "The NAPPS Termly Unified Examination Committee hereby welcome all our distinguished leaders and respected ...",
    moreDetails:
      "Our seven research themes span the full range of research activities being carried out in the Laboratory and reflect national research priorities. Many themes cover the work of more than one research group, encouraging new associations and cross-disciplinary collaboration. While the core of our research programme is in experimental physics, essential theoretical support is provided by theorists embedded within the astrophysics and high energy physics research groups, while the condensed matter theory group are strongly cross-disciplinary and contribute to most of the themes shown above.",

    id: 3,
  },
  {
    newsHeading: "TEACHERS TRAINING WORKSHOP..",
    img: Img4,
    date: "25 june 2023",
    view: "59",
    comment: "19",
    newsDetails:
      "TEACHERS TRAINING WORKSHOP Promoting Intergrity: Strategies for Mitigating Examination Malpractice in Schools",
    moreDetails:
      "Our seven research themes span the full range of research activities being carried out in the Laboratory and reflect national research priorities. Many themes cover the work of more than one research group, encouraging new associations and cross-disciplinary collaboration. While the core of our research programme is in experimental physics, essential theoretical support is provided by theorists embedded within the astrophysics and high energy physics research groups, while the condensed matter theory group are strongly cross-disciplinary and contribute to most of the themes shown above.",

    id: 4,
  },
  {
    newsHeading: "TEACHERS TRAINING WORKSHOP..",
    img: Img4,
    date: "25 june 2023",
    view: "59",
    comment: "19",
    newsDetails:
      "TEACHERS TRAINING WORKSHOP Promoting Intergrity: Strategies for Mitigating Examination Malpractice in Schools",
    moreDetails:
      "Our seven research themes span the full range of research activities being carried out in the Laboratory and reflect national research priorities. Many themes cover the work of more than one research group, encouraging new associations and cross-disciplinary collaboration. While the core of our research programme is in experimental physics, essential theoretical support is provided by theorists embedded within the astrophysics and high energy physics research groups, while the condensed matter theory group are strongly cross-disciplinary and contribute to most of the themes shown above.",

    id: 5,
  },
  {
    newsHeading: "TEACHERS TRAINING WORKSHOP..",
    img: Img4,
    date: "25 june 2023",
    view: "59",
    comment: "19",
    newsDetails:
      "TEACHERS TRAINING WORKSHOP Promoting Intergrity: Strategies for Mitigating Examination Malpractice in Schools",
    moreDetails:
      "Our seven research themes span the full range of research activities being carried out in the Laboratory and reflect national research priorities. Many themes cover the work of more than one research group, encouraging new associations and cross-disciplinary collaboration. While the core of our research programme is in experimental physics, essential theoretical support is provided by theorists embedded within the astrophysics and high energy physics research groups, while the condensed matter theory group are strongly cross-disciplinary and contribute to most of the themes shown above.",

    id: 6,
  },
  {
    newsHeading: "TEACHERS TRAINING WORKSHOP..",
    img: Img4,
    date: "25 june 2023",
    view: "59",
    comment: "19",
    newsDetails:
      "TEACHERS TRAINING WORKSHOP Promoting Intergrity: Strategies for Mitigating Examination Malpractice in Schools",
    moreDetails:
      "Our seven research themes span the full range of research activities being carried out in the Laboratory and reflect national research priorities. Many themes cover the work of more than one research group, encouraging new associations and cross-disciplinary collaboration. While the core of our research programme is in experimental physics, essential theoretical support is provided by theorists embedded within the astrophysics and high energy physics research groups, while the condensed matter theory group are strongly cross-disciplinary and contribute to most of the themes shown above.",

    id: 7,
  },
  {
    newsHeading: "TEACHERS TRAINING WORKSHOP..",
    img: Img4,
    date: "25 june 2023",
    view: "59",
    comment: "19",
    newsDetails:
      "TEACHERS TRAINING WORKSHOP Promoting Intergrity: Strategies for Mitigating Examination Malpractice in Schools",
    moreDetails:
      "Our seven research themes span the full range of research activities being carried out in the Laboratory and reflect national research priorities. Many themes cover the work of more than one research group, encouraging new associations and cross-disciplinary collaboration. While the core of our research programme is in experimental physics, essential theoretical support is provided by theorists embedded within the astrophysics and high energy physics research groups, while the condensed matter theory group are strongly cross-disciplinary and contribute to most of the themes shown above.",

    id: 8,
  },
  {
    newsHeading: "TEACHERS TRAINING WORKSHOP..",
    img: Img4,
    date: "25 june 2023",
    view: "59",
    comment: "19",
    newsDetails:
      "TEACHERS TRAINING WORKSHOP Promoting Intergrity: Strategies for Mitigating Examination Malpractice in Schools",
    moreDetails:
      "Our seven research themes span the full range of research activities being carried out in the Laboratory and reflect national research priorities. Many themes cover the work of more than one research group, encouraging new associations and cross-disciplinary collaboration. While the core of our research programme is in experimental physics, essential theoretical support is provided by theorists embedded within the astrophysics and high energy physics research groups, while the condensed matter theory group are strongly cross-disciplinary and contribute to most of the themes shown above.",

    id: 9,
  },
  {
    newsHeading: "TEACHERS TRAINING WORKSHOP..",
    img: Img4,
    date: "25 june 2023",
    view: "59",
    comment: "19",
    newsDetails:
      "TEACHERS TRAINING WORKSHOP Promoting Intergrity: Strategies for Mitigating Examination Malpractice in Schools",
    moreDetails:
      "Our seven research themes span the full range of research activities being carried out in the Laboratory and reflect national research priorities. Many themes cover the work of more than one research group, encouraging new associations and cross-disciplinary collaboration. While the core of our research programme is in experimental physics, essential theoretical support is provided by theorists embedded within the astrophysics and high energy physics research groups, while the condensed matter theory group are strongly cross-disciplinary and contribute to most of the themes shown above.",

    id: 10,
  },
];
